<template>
  <div v-if="filesLoaded.length > 0" class="loaded-files-wrapper">
    <div
      v-for="file in filesLoaded"
      :key="file.name"
      aria-label="Área de Arquivos já enviados."
      :class="[
        'loaded-file mt-2',
        !!isInvalid(file) ? 'loaded-file--error' : '',
      ]"
    >
      <div class="loaded-file__icon">
        <Icon name="file-lines" />
      </div>

      <div class="loaded-file__content">
        <div class="w-80 loaded-file__name text-wrap">
          {{ file.name }}
        </div>

        <div class="loaded-file__error">
          {{ isInvalid(file) }}
        </div>
      </div>

      <div
        class="loaded-file__action"
        style="cursor: pointer"
        @click="deleteFile(file)"
        @keydown="deleteFile(file)"
      >
        <Icon name="x" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'

  export default defineComponent({
    name: 'FilesLoader',
    components: {
      Icon,
    },
    emits: ['handleDeleteFile'],
    props: {
      filesLoaded: {
        type: Array as PropType<File[]>,
        default: Array,
      },
      extensionTypes: {
        type: Array as PropType<string[]>,
        required: true,
      },
    },
    methods: {
      isInvalid(item: File) {
        const hasValidFile = this.extensionTypes.includes(
          item.type.split('/')[1],
        )
        if (this.bytesToMegabytes(item.size) > 25) {
          return 'Limite máximo de MB excedido.'
        }
        return hasValidFile ? '' : 'Formato inválido.'
      },
      deleteFile(file: File) {
        this.$emit('handleDeleteFile', this.filesLoaded.indexOf(file))
      },
      bytesToMegabytes(bytes: number) {
        return bytes / (1024 * 1024)
      },
    },
  })
</script>
